import { DataLoadedStatus, SectionStatusType } from '../../types';
import { ContentControlWebSectionState } from './content-control.types';

export const defaultContentControlWebState: ContentControlWebSectionState = {
  isValid: true,
  status: { type: SectionStatusType.NONE },
  additionalInfo: {
    schedulersLoaded: DataLoadedStatus.NOT_LOADED,
  },
};
